// Znak aplikacji „LEGIA HUB" (projekt z Claude Design, 15.10.2026): LEGIA w kolorze
// tekstu, HUB złote. Na ciemnym tle (belka, ekrany logowania) — tekst biały.
// Ten sam znak w faviconie (public/favicon.svg: białe L, złote H na forest).
export function LegiaHubWordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-extrabold tracking-[0.04em] ${className}`}>
      LEGIA <span className="text-brand-gold">HUB</span>
    </span>
  )
}
